// extracted by mini-css-extract-plugin
export default {"root":"p_x9Fi"};